var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBlueCircleButton = function SvgBlueCircleButton(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72.5,
    height: 72.5,
    viewBox: "0 0 72.5 72.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol_1038",
    "data-name": "Symbol 1038",
    transform: "translate(-151.75 -513.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol_308_8",
    "data-name": "Symbol 308 \\u2013 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ellipse",
    d: "M36,0A36,36,0,1,1,0,36,36,36,0,0,1,36,0Z",
    transform: "translate(152 514)",
    fill: "#07a3c8",
    stroke: "#07a3c8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M19487.16-371.408v-6.885h-6.885a1.269,1.269,0,0,1-1.271-1.272,1.273,1.273,0,0,1,1.271-1.277h6.885v-6.88a1.275,1.275,0,0,1,1.273-1.277,1.278,1.278,0,0,1,1.275,1.277v6.88h6.887a1.277,1.277,0,0,1,1.271,1.277,1.273,1.273,0,0,1-1.271,1.272h-6.887v6.885a1.273,1.273,0,0,1-1.275,1.272A1.27,1.27,0,0,1,19487.16-371.408Z",
    transform: "translate(-13860.46 -12961.674) rotate(45)",
    fill: "#f9f9f9",
    stroke: "#f9f9f9",
    strokeWidth: 1
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlueCircleButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blueCircleButton.3696d2ec.svg";
export { ForwardRef as ReactComponent };